<template>
  <v-container
    fluid
  >
    <v-row>
      <v-expansion-panels
        v-model="panel"
        :disabled="disabled"
        multiple
      >
        <v-expansion-panel>
          <v-expansion-panel-header>M_P_Feuerwehrplan</v-expansion-panel-header>
          <v-expansion-panel-content>Some content</v-expansion-panel-content>
        <v-expansion-panel>
        </v-expansion-panel>
          <v-expansion-panel-header>M_P_Übungsdienst-HNR9</v-expansion-panel-header>
          <v-expansion-panel-content>Some content</v-expansion-panel-content>
        <v-expansion-panel>
        </v-expansion-panel>
          <v-expansion-panel-header>M_P_Kommunikationsliste aktualisieren</v-expansion-panel-header>
          <v-expansion-panel-content>Some content</v-expansion-panel-content>
        <v-expansion-panel>
        </v-expansion-panel>
          <v-expansion-panel-header>M_P_Sirenenstörung</v-expansion-panel-header>
          <v-expansion-panel-content>Some content</v-expansion-panel-content>
        <v-expansion-panel>
        </v-expansion-panel>
          <v-expansion-panel-header>M_P_Einsatzmittel / OPTA aktualiseren</v-expansion-panel-header>
          <v-expansion-panel-content>Some content</v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Panel 2</v-expansion-panel-header>
          <v-expansion-panel-content>
            Some content
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Panel 3</v-expansion-panel-header>
          <v-expansion-panel-content>
            Some content
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>


export default {
  name: "TestView",
  data() {
    return {
      panel: [],
      disabled: false,
      readonly: false,

    };
  },
};
</script>

<style scoped>

</style>
